export default __webpack_public_path__ + "static/media/Y.c80c1167.svg";